import ArrowBack from "@mui/icons-material/ArrowBack";
import { Box, IconButton } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import CaptainInfo from "../../components/captain/CaptainInfo/CaptainInfo";
import CaptainVideo from "../../components/captain/CaptainVideo/CaptainVideo";
import ScrollAnimationWrapper from "../../components/layouts/Animations/ScrollAnimationWrapper";
import Divider from "../../components/layouts/Divider/Divider";
import Footer from "../../components/layouts/Footer/Footer";
import KeyDetails from "../../components/ui-elements/KeyDetails/keyDetails";
import StatisticsV2 from "../../components/ui-elements/Statistics/Statistics";
import { Captain } from "../../types/Captain";
import { backButton, captainProfileContainer } from "./captainDetailPageStyles";

interface CaptainDetailProps {
    captain: Captain;
}

const CaptainDetailPage: React.FC<CaptainDetailProps> = ({ captain }) => {
    const navigate = useNavigate();
    const nextComponentRef = useRef<HTMLDivElement>(null);
    const videoRef = useRef<HTMLDivElement>(null);
    const [videoEnded, setVideoEnded] = useState(false);
    const [showBackButton, setShowBackButton] = useState(false);

    const scrollToNextComponent = () => {
        setVideoEnded(true);
        if (nextComponentRef.current) {
            const nextComponentTop =
                nextComponentRef.current.getBoundingClientRect().top +
                window.scrollY;
            window.scrollTo({
                top: nextComponentTop - 20,
                behavior: "smooth",
            });
        }
    };

    const handlers = useSwipeable({
        onSwipedRight: () => navigate(-1),
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    useEffect(() => {
        const handleScroll = () => {
            if (videoRef.current) {
                const videoBottom =
                    videoRef.current.getBoundingClientRect().bottom;

                if (videoBottom <= 20) {
                    setShowBackButton(true);
                } else {
                    setShowBackButton(false);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <Box {...handlers} sx={captainProfileContainer}>
            {captain.videoUrl && (
                <Box ref={videoRef}>
                    <CaptainVideo
                        videoUrl={captain.videoUrl}
                        onVideoEnd={scrollToNextComponent}
                    />
                </Box>
            )}

            {showBackButton && (
                <Box sx={backButton}>
                    <IconButton
                        onClick={() => navigate(-1)}
                        sx={{ color: "primary.main" }}
                    >
                        <ArrowBack />
                    </IconButton>
                </Box>
            )}
            <Box ref={nextComponentRef}>
                <CaptainInfo captain={captain} />
            </Box>
            <ScrollAnimationWrapper>
                <KeyDetails details={captain.keyDetails} />
            </ScrollAnimationWrapper>

            <ScrollAnimationWrapper>
                <Divider />
            </ScrollAnimationWrapper>

            <ScrollAnimationWrapper>
                <StatisticsV2
                    statistics={captain.statistics}
                    lottieAnimationData={"path-to-lottie1.json"}
                    lottieAnimationData2={"path-to-lottie2.json"}
                    videoEnded={videoEnded}
                />
            </ScrollAnimationWrapper>

            <Footer />
        </Box>
    );
};

export default CaptainDetailPage;
